var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alltitle"},[_c('div',{staticClass:"banner wow animate fadeInUp"}),_c('div',{staticClass:"fournavoutside wow animate fadeInUp delay-200ms"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }